import { render, staticRenderFns } from "./UserInput.vue?vue&type=template&id=a4b9d2e0&scoped=true"
import script from "./UserInput.vue?vue&type=script&lang=js"
export * from "./UserInput.vue?vue&type=script&lang=js"
import style0 from "./UserInput.vue?vue&type=style&index=0&id=a4b9d2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b9d2e0",
  null
  
)

export default component.exports